import { __assign, __rest } from "tslib";
import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { Grid, createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, DatePicker as Picker, TimePicker } from "@material-ui/pickers";
var defaultMaterialTheme = createTheme({
    palette: {
        primary: {
            main: "rgba(38, 79, 174, 1)"
        }
    },
    typography: {
        allVariants: {
            color: "hsl(224,18%,12%)"
        }
    }
});
export var DatePicker = function (_a) {
    var _b = _a.isTimePicker, isTimePicker = _b === void 0 ? false : _b, props = __rest(_a, ["isTimePicker"]);
    return (React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
        React.createElement(Grid, { container: true, justifyContent: "space-around" },
            React.createElement(ThemeProvider, { theme: defaultMaterialTheme }, isTimePicker ? React.createElement(TimePicker, __assign({}, props)) : React.createElement(Picker, __assign({}, props))))));
};
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map